export enum PhysicalProductTabEnum {
  thumbnail = 'thumbnail',
  checkout = 'checkout',
  physical_product = 'physical_product',
  thank_you = 'thank_you',
}

export const tabLocoKeys: Record<PhysicalProductTabEnum, string> = {
  [PhysicalProductTabEnum.thumbnail]: 'dashboard.store.item.thumbnail',
  [PhysicalProductTabEnum.checkout]: 'dashboard.store.item.checkout',
  [PhysicalProductTabEnum.physical_product]: 'dashboard.store.item.physical_product.title',
  [PhysicalProductTabEnum.thank_you]: 'dashboard.store.item.thank_you_page',
}
